export default "__VITE_ASSET__DYYG0brO__"